export const API = {
  uploadFile: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/UploadFile`,
  downloadFile: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/DownloadFileByDocId?documentId=`,
  downloadFileForCms: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/DownloadFileByDocIdForCms?documentId=`,
  downloadFileByName: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/DownloadFileByFileName?fileName=`,
  downloadFileByReportId: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/DownloadCmsFileById?reportId=`,
  downloadFileProducerIdsByReportId: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/DownloadProducerListReport?reportId=`,
  downloadFileByFileName: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/DownloadFileByFileName?fileName=email-attachments%2f<file-name-here>&getByFileNameOnly=false`,
  downloadMyDocument: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/Asset/download-mydocument?documentId=`,
  downloadNonGroupedProducersList: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/DownloadNonGroupedProducersList`,
  saveLogWhenUserLoginErrors: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/personal-data/Producer/SaveLogWhenUserLoginErrors`,
  uploadMyDocument: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/Asset/upload-mydocument`,
  wirteFELog: `${window.REACT_APP_API_GATEWAY_URL}/logging/api/logging/client-error`,
};


export const SERVER_RESPONSE_CODES = {
  Success: 0,
  Fail: 10,
  Invalid: 20,
  Valid: 30,
  Available: 40,
  NotAvailable: 50,
  FailWithException: 60,
  InProgress: 70,
  Completed: 80,
};